module.exports = __webpack_public_path__ + "static/media/APCO Institute White Logo_1719597737109.402ad196.png";